module.exports = __webpack_public_path__ + "static/img/image013.c60d8d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/雷达安装说明.files/image013.jpg
// module id = PPJ6
// module chunks = 1